import { customEvent, StorageEvents } from '@dxp-module/common';
import { useCallback, useState } from 'react';
import * as queryString from 'query-string';
import { useLoginMutation } from '../graphql/__generated__/graphql.autogenerated';
import { tokenService } from '../services/tokenService';
import useLoginContext from './useLoginContext';
const useLogin = () => {
    const { onLoginSuccess } = useLoginContext();
    const [mutation, { data, loading }] = useLoginMutation();
    const [error, setError] = useState();
    const params = queryString.parse(window.location.search);
    const getDealId = params?.dealId ? params.dealId : null;
    const getToken = params?.token ? params.token : null;
    const dealId = getToken || getDealId;
    const login = useCallback((email, password) => {
        mutation({
            variables: {
                email,
                password,
                ...(dealId && { dealId }),
            },
        })
            .then(response => {
            const token = response?.data?.login.accessToken;
            if (token) {
                tokenService.store(token);
                customEvent.emit(StorageEvents.ON_STORE_ACCESS_TOKEN, null);
                onLoginSuccess && onLoginSuccess(token);
            }
        })
            .catch(error => setError(error));
    }, [mutation, onLoginSuccess]);
    return { login, data, loading, error };
};
export default useLogin;
//# sourceMappingURL=useLogin.js.map